import type { StateHolder } from '@/util/dataState';

/**
 * Organisation feature keys. Values MUST match the backend
 * `formus_domain.organisation_features.FeatureName` — they arrive over the
 * wire in the organisation profile response.
 */
export enum OrganisationFeature {
    OrderSurgicalGuide = 'order_surgical_guide',
    HipSpine = 'hip_spine',
}

export type OrganisationFeatureSet = Record<OrganisationFeature, boolean>;

export type OrganisationProfileState = {
    features: OrganisationFeatureSet;
} & StateHolder;
